import React, { useState } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Sidebar from './Sidebar'
import TopBar from './TopBar'
import { useAuthentication } from '../hooks/useAuthentication'

// Panel
import Dashboard from '../components/Dashboard'
import InboxVouchers from '../components/Inbox'
import Details from '../components/Inbox/Details'
import Vouchers from '../components/Vouchers'
import Me from '../components/Me'
import Reports from '../components/Reports'
import Budgets from '../components/Budgets'
import BudgetReport from '../components/Budgets/Report'
import ExportVouchers from '../components/Vouchers/ExportView'

// Admin
import Users from '../components/Admin/Users'
import Roles from '../components/Admin/Roles'
import Workflows from '../components/Admin/Workflows'
import VouchersManagement from '../components/Admin/VouchersManagement'
import Activities from '../components/Admin/Activities'

const AppShell: React.FC = () => {
  const { authState } = useAuthentication()
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <TopBar onMenuClick={() => setMobileOpen(true)} />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Container maxWidth={false} sx={{ py: 2 }}>
            <Switch>
              {/* Dashboard */}
              <Route exact path="/panel" component={Dashboard} />

              {/* Inbox */}
              <Route exact path="/panel/inbox" component={InboxVouchers} />
              <Route path="/panel/inbox/:id/edit" component={Details} />

              {/* Vouchers */}
              <Route exact path="/panel/vouchers" component={Vouchers} />
              <Route path="/panel/vouchers/:id/edit" component={Details} />

              {/* Me */}
              <Route path="/panel/me" component={Me} />
              <Route path="/panel/export" component={ExportVouchers} />

              {/* Reports */}
              <Route exact path="/panel/reports" component={Reports} />
              <Route path="/panel/reports/:id/edit" component={Details} />

              {/* Budgets */}
              <Route exact path="/panel/budgets" component={Budgets} />
              <Route
                exact
                path="/panel/budget-report"
                component={BudgetReport}
              />

              {/* Admin -- gated once, same as the old AdminWrapper */}
              <Route path="/admin">
                {!authState.authUser.site_admin ? (
                  <Redirect to="/panel" />
                ) : (
                  <Switch>
                    <Route exact path="/admin">
                      <Redirect to="/admin/users" />
                    </Route>
                    <Route path="/admin/users" component={Users} />
                    <Route path="/admin/roles" component={Roles} />
                    <Route path="/admin/workflows" component={Workflows} />
                    <Route
                      path="/admin/vouchers"
                      component={VouchersManagement}
                    />
                    <Route path="/admin/activities" component={Activities} />
                  </Switch>
                )}
              </Route>
            </Switch>
          </Container>
        </Box>
      </Box>
    </Box>
  )
}

export default AppShell
